<div fxLayout="column" fxLayoutAlign="start center" fxFlexFill>

  <div fxLayout="column" fxLayoutGap="10px" class="form-auth" ngClass.xs="full-w">

    <!-- Need Sms code
    <div fxLayout="column" fxLayoutAlign="center center" class="text-center" *ngIf="!smsApi.conditionSms()">
      <span class="mat-subheading-1">{{"loginComp.no_account" | translate}}</span>
      <span class="mat-subheading-1">{{"loginComp.sms_code" | translate}} <strong class="clicked"
          (click)="authManPag.moveToRegister()">{{"loginComp.inscription" | translate}}</strong></span>
    </div>-->

    <!-- Error && Success Cards -->
    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'errHappen'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>warning</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"loginComp.error" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'noregister'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>warning</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2">{{"loginComp.noKey" | translate}}</span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'erremailalreadyuse'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>email</mat-icon>
      </div>
      <div fxLayout="column" fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2"
          [innerHTML]="'register.message.takenemail' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'user'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>person</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2" [innerHTML]="'main.err.noaccount' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'password'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>https</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2" [innerHTML]="'login.err.nomatchemail' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <mat-card fxLayout="row" fxLayoutAlign="center center" class="warn" *ngIf="error$ === 'emailpass'">
      <div fxFlex="10%" fxLayoutAlign="start center">
        <mat-icon>person</mat-icon>
      </div>
      <div fxFlex fxLayoutAlign="center center" class="text-center">
        <span class="mat-subheading-2" [innerHTML]="'login.err.credalready' | translate:{'email': currEmail}"></span>
      </div>
    </mat-card>

    <!-- Login form -->
    <form fxLayout="column" fxLayoutGap="10px" fxLayoutGap.xs="0" [formGroup]="loginForm" #formDirective="ngForm"
      (ngSubmit)="submitLogin(formDirective)">

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"main.word.email" | translate}}</mat-label>
          <input type="email" matInput placeholder="{{'main.word.email' | translate}}" formControlName="email" autocomplete="username">
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('email')">
            <span class="mat-caption">{{"main.err.reqemail" | translate}}</span>
          </mat-error>
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="loginForm.controls['email'].errors?.email">
            <span class="mat-caption">{{"main.err.emailformat" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <div class="form-field-endorder">

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>{{"main.word.password" | translate}}</mat-label>
          <input type="password" matInput placeholder="{{'main.word.password' | translate}}" formControlName="password" autocomplete="new-password">
          <mat-error fxLayout fxLayoutAlign="start center" *ngIf="isFieldrequired('password')" >
            <span class="mat-caption">{{"main.err.reqpass" | translate}}</span>
          </mat-error>
        </mat-form-field>

      </div>

      <button [ngClass]="cssService.defaultActionButton" angulartics2On="click" angularticsAction="submitLoginForm"
        angularticsCategory="login">{{"main.word.login" | translate}}

      </button>

    </form>

    <!-- Credentials -->
    <div class="flex flex-col w-full">
      <app-credentials [currEmail]="currEmail" [redirectPage]="redirectPage"></app-credentials>
    </div>

    <!-- Forgot Password -->
    <div class="flex flex-row justify-end items-center mt-4">
      <button class="text-sm text-gray-800" (click)="authManPag.moveToForgotPass()" angulartics2On="click"
         angularticsAction="redirectForgotPassword" angularticsCategory="login">{{"login.other.goforgpass" |
        translate}}</button>
    </div>

  </div>

  <app-popup-loader [flagLoading]="loaderLogin" [size]="30"></app-popup-loader>

</div>
